module.exports = "<input type=\"text\"\r\n       ng-model=\"fakeVM.value\"\r\n       ng-blur=\"applyNewValue()\"/>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/table/templates/Input.html
// module id = 447
// module chunks = 0